module.exports = __webpack_public_path__ + "img/gold2.3acfa6fd.png";